// 前端系统常量

module.exports = {
	/**
	 * 成功提示信息
	 */
	successPromptTotal: {
		exportPrompt: '文件导入中，可消息中心查看导入结果',
		exportFormatPrompt: '系统需要表格数据格式错误',
		handlerPrompt: '操作成功',
	},
	/**
	 * 具有项目信息查询business_key
	 */
	checkProjectBusinessKey: [
		{ business_key: 'ReceivableHomePage', dl_dm: 'YSK', has_project_business_key: 'GainDetailsEmpty' },
	],
	/**
	 * 短信验证码倒计时
	 */
	verifyCodeCountdown: 120,
	/**
	 * DataGrid控件pageSize数组(修改)
	 */
	dataGridPageSizeArr: [30, 50, 100],
	/**
	 * 版本号
	 */
	version: 'v1.1.0',
	/**
	 * buildCode
	 */
	buildCode: 39,
	// // 服务器地址
	// serverHost: '192.168.0.242',    // 192.168.0.222    192.168.0.133   47.100.212.168
	// // serverHost: '47.100.212.168',    // 192.168.0.222    192.168.0.133   47.100.212.168
	// // 服务器路径
	// serverPath: '',
	// // 服务器端口
	// // serverPort: 8080, // 8080
	// serverPort: 9030,
	// // 打印配置
	// printStyle:'local',//local  cloud
	// printHost:'192.168.0.99',
	printPort1: '8000',
	printPort2: '18000',
	printHTTPSPort1: '8443',
	printHTTPSPort2: '8444',
};
